/**
 * godepth 式网格底（参考 blog/frontend/src/components/AnimatedBackground.tsx 的 grid 变体）。
 * 两层网格：30px 细格 + 150px 粗格，冷蓝极淡。
 * 刻意**不做**鼠标视差 —— 原版每次 mousemove 都 setState 重渲染，行情页承受不起。
 */
export function GridBackground() {
  return (
    <div aria-hidden className="pointer-events-none fixed inset-0 z-0 opacity-40 dark:opacity-20">
      <div
        className="absolute inset-0"
        style={{
          backgroundImage:
            'linear-gradient(rgba(59,130,246,0.08) 1px, transparent 1px), linear-gradient(90deg, rgba(59,130,246,0.08) 1px, transparent 1px)',
          backgroundSize: '30px 30px',
        }}
      />
      <div
        className="absolute inset-0"
        style={{
          backgroundImage:
            'linear-gradient(rgba(14,165,233,0.06) 1px, transparent 1px), linear-gradient(90deg, rgba(14,165,233,0.06) 1px, transparent 1px)',
          backgroundSize: '150px 150px',
        }}
      />
    </div>
  );
}
